module.exports = __webpack_public_path__ + "static/media/DISCHARGE_ON.fe7013d0.png";